import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { Notes } from "MODULES/shared/components";
import loadRecord from "MODULES/shared/decorators/loadRecord";
import Attachments from "MODULES/shared/components/Attachments/Attachments";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import { Col } from "react-bootstrap";
import HeaderBar from "./Header";
import Discrepancies from "./Discrepancies/Discrepancies";
import SideBar from "./SideBar";
import QuestionsChecklist from "./QuestionsChecklist";
import { show } from "../actions";
import { ATTACHMENT_TYPES } from "../constants";

function Detail({ receivingRecord }) {
  const formVersion = receivingRecord.get("discrepancies_form_version_number");

  return (
    <div>
      <HeaderBar receivingRecord={receivingRecord} />
      <SideBar receivingRecord={receivingRecord} />
      <Col md={9}>
        <Discrepancies formVersion={formVersion} />
        <hr className="hr-dashed" />
        <Attachments
          multiple
          resource={receivingRecord}
          resourceType={resourceTypes.receivingRecord}
          resourceKey="receivingRecord"
          attachmentTypes={ATTACHMENT_TYPES}
        />
        <Notes
          resource={receivingRecord}
          resourceType={resourceTypes.receivingRecord}
          resourceKey="receivingRecord"
        />
        <hr className="hr-dashed" />
        <QuestionsChecklist receivingRecord={receivingRecord} />
      </Col>
    </div>
  );
}

Detail.propTypes = {
  receivingRecord: PropTypes.instanceOf(Map).isRequired
};

export default connect(state => ({
  receivingRecord: state.receivingRecordDetail.get("receivingRecord")
}))(
  loadRecord({
    reducer: "receivingRecordDetail",
    name: "receivingRecord",
    action: show
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Detail.jsx